module.exports = __webpack_public_path__ + "img/JNY-HCP-mobile_0785.238193c7.jpg";